import React from 'react';
import styled from 'styled-components';
//
import Image from './image';
import Video from './video-fetch';
//
export default ({ items }) => {
  if (!items || items.length < 1) {
    return null;
  }

  return (
    <Wrap>
      {items.map(({ node }) => (
        <Item key={node.id}>
          {node.is_video ? <Video {...node} /> : <Image {...node} />}
        </Item>
      ))}
    </Wrap>
  );
};
//
const Wrap = styled.div`
  padding: 0 0 1px;
  width: 100%;
`;
const Item = styled.div`
  margin: 0 auto 1vw;
`;
